import { render, staticRenderFns } from "./ticket-manage.vue?vue&type=template&id=b26acfe4&scoped=true&"
import script from "./ticket-manage.vue?vue&type=script&lang=js&"
export * from "./ticket-manage.vue?vue&type=script&lang=js&"
import style0 from "./ticket-manage.vue?vue&type=style&index=0&id=b26acfe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26acfe4",
  null
  
)

export default component.exports